export const hiddenScrollbarSx = {
  overflowY: 'auto',
  overflowX: 'hidden',

  scrollbarWidth: 'none',
  msOverflowStyle: 'none',

  '&::-webkit-scrollbar': {
    display: 'none',
    width: 0,
    height: 0
  }
};

export const dialogPaperSx = {


  height: 'calc(100vh - 64px)',
  maxHeight: 'calc(100vh - 64px)',
  minHeight: 0,

  m: 0,

  borderRadius: 1,

  display: 'grid',

  gridTemplateRows:
    'auto minmax(0, 1fr) auto',

  overflow: 'hidden'
};

export const dialogTitleSx = {
  px: 1.5,
  py: 1,

  bgcolor: '#F8FAFD',

  borderBottom: '1px solid #E0E0E0'
};

export const headerWrapperSx = {
  display: 'flex',

  alignItems: 'flex-start',

  justifyContent: 'space-between'
};

export const encounterTitleSx = {
  color: '#424242',

  fontSize: 13,

  fontWeight: 600
};

export const encounterDateSx = {
  mt: 0.15,

  color: '#757575',

  fontSize: 9
};

export const closeButtonSx = {
  p: 0.25,

  color: '#424242',

  '&:hover': {
    bgcolor: 'transparent',

    color: '#1976D2'
  }
};

export const dialogContentSx = {
  p: '0 !important',

  minWidth: 0,
  minHeight: 0,

  display: 'flex',
  flexDirection: 'column',

  overflow: 'hidden'
};

/**
 * Medical Hx visible:
 * LEFT 58%
 * RIGHT 42%
 *
 * Medical Hx hidden:
 * LEFT 100%
 */
export const getEncounterBodySx = (isMedicalHxHidden) => ({
  width: '100%',
  flex: 1,

  minWidth: 0,
  minHeight: 0,

  display: 'grid',
  gap:1,

  gridTemplateColumns: {
    xs: '1fr',
    md: isMedicalHxHidden
      ? '100fr 0fr'
      : '58fr 42fr'
  },

  transition:
    'grid-template-columns 320ms cubic-bezier(0.4, 0, 0.2, 1)',

  overflow: 'hidden'
});

export const getLeftPanelSx = (isMedicalHxHidden) => ({
  minWidth: 0,
  minHeight: 0,

  height: '100%',
  maxHeight: '100%',

  boxSizing: 'border-box',

  ...hiddenScrollbarSx,

  borderRight: {
    xs: 'none',
    md: isMedicalHxHidden
      ? '1px solid transparent'
      : '1px solid #E0E0E0'
  },

  transition:
    'border-color 200ms cubic-bezier(0.4, 0, 0.2, 1)'
});

export const getRightPanelSx = (isMedicalHxHidden) => ({
  minWidth: 0,
  minHeight: 0,

  height: '100%',

  display: 'grid',
  gridTemplateRows: 'auto minmax(0, 1fr)',

  bgcolor: '#FFFFFF',

  overflow: 'hidden',

  opacity: isMedicalHxHidden ? 0 : 1,

  pointerEvents: isMedicalHxHidden
    ? 'none'
    : 'auto',

  transition:
    'opacity 180ms cubic-bezier(0.4, 0, 0.2, 1)'
});
/**
 * Sticky patient row
 */
export const patientHeaderSx = {
  minHeight: 42,

  px: 1.5,

  display: 'flex',

  alignItems: 'center',

  justifyContent: 'space-between',

  gap: 1,

  bgcolor: '#FFFFFF',

  borderBottom: '1px solid #E8E8E8',

  position: 'sticky',

  top: 0,

  zIndex: 10
};

export const patientInfoWrapperSx = {
  minWidth: 0,

  display: 'flex',

  alignItems: 'center',

  gap: 0.75
};

export const patientNameSx = {
  color: '#424242',

  fontSize: 13,

  fontWeight: 600,

  whiteSpace: 'nowrap',

  overflow: 'hidden',

  textOverflow: 'ellipsis'
};

export const patientInfoSx = {
  color: '#424242',

  fontSize: 10,
  fontWeight:400,

  whiteSpace: 'nowrap'
};

export const topActionsSx = {
  flexShrink: 0,

  display: 'flex',

  alignItems: 'center',

  gap: 0.75
};

export const topActionButtonSx = {
  minWidth: 0,

  height: 28,

  px: 1,

  color: '#424242',

  borderColor: '#D7D7D7',

  borderRadius: '3px',

  fontSize: 12,

  fontWeight: 500,

  textTransform: 'none',

  boxShadow: 'none',

  '& .MuiButton-startIcon': {
    mr: 0.5
  },

  '& .MuiSvgIcon-root': {
    fontSize: 16
  }
};

export const soapButtonSx = {
  ...topActionButtonSx,

  bgcolor: '#FFF8E8',

  '&:hover': {
    bgcolor: '#FFF3D2',

    borderColor: '#D7C9A1',

    boxShadow: 'none'
  }
};

export const hpButtonSx = {
  ...topActionButtonSx,

  bgcolor: '#EFF8FC',

  '&:hover': {
    bgcolor: '#E3F2F8',

    borderColor: '#B7D4E0',

    boxShadow: 'none'
  }
};

export const leftContentSx = {
  px: 1.5,
  py: 1.25
};

/**
 * RIGHT / MEDICAL HX
 */
export const rightPanelSx = {
  minWidth: 0,
  minHeight: 0,

  height: '100%',

  display: 'grid',

  gridTemplateRows:
    'auto minmax(0, 1fr)',

  overflow: 'hidden',

  bgcolor: '#FFFFFF'
};

/**
 * Sticky Medical Hx header
 */
export const rightHeaderSx = {
  minHeight: 42,

  px: 1.25,

  display: 'flex',

  alignItems: 'center',

  justifyContent: 'space-between',

  bgcolor: '#FFFFFF',

  borderBottom: '1px solid #E0E0E0',

  position: 'sticky',

  top: 0,

  zIndex: 10
};

export const rightHeaderTitleSx = {
  color: '#424242',

  fontSize: 11,

  fontWeight: 500
};

export const expandButtonSx = {
  width: 26,

  height: 26,

  p: 0.25,

  color: '#424242',

  '& svg': {
    width: 18,

    height: 18
  },

  '&:hover': {
    bgcolor: '#F5F5F5',

    color: '#1976D2'
  }
};

/**
 * Rotate icon when it is used
 * to reopen Medical Hx.
 */
export const restoreIconSx = {
  display: 'flex',

  alignItems: 'center',

  justifyContent: 'center',

  transform: 'rotate(180deg)'
};

export const rightScrollContentSx = {
  width: '100%',

  minWidth: 0,

  minHeight: 0,

  ...hiddenScrollbarSx
};

/**
 * FOOTER
 */
export const footerSx = {
  minHeight: 54,

  px: 1.5,

  py: 1,

  display: 'flex',

  alignItems: 'center',

  justifyContent: 'space-between',

  gap: 2,

  bgcolor: '#FFFFFF',

  borderTop: '1px solid #E0E0E0'
};

export const signedBySx = {
  color: '#424242',

  fontSize: 10,

  whiteSpace: 'nowrap'
};

export const footerActionsSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  gap: 1.2
};

export const footerButtonSx = {
  height: 30,
  px: 1.25,

  fontSize: 12,
  textTransform: 'uppercase',
  color: '#424242',

  // Reduce icon → text spacing
  '& .MuiButton-startIcon': {
    marginRight: '4px',
    marginLeft: 0
  },

  // Reduce icon size
  '& .MuiButton-startIcon svg': {
    fontSize: 16
  }
};

export const deleteButtonSx = {
  ...footerButtonSx,
  borderColor: '#E0E0E0'
};

export const copyButtonSx = {
  ...footerButtonSx,
  bgcolor: '#C8E6C9',
  borderColor: '#81C784',

  '&:hover': {
    bgcolor: '#DFF1E1',
    borderColor: '#A5D6A7'
  }
};

export const editButtonSx = {
  ...footerButtonSx,
  bgcolor: '#EFDCB5',
  borderColor: '#E5C686',

  '&:hover': {
    bgcolor: '#FCEBC0',
    borderColor: '#E2CA89'
  }
};

export const signButtonSx = {
  ...footerButtonSx,
  bgcolor: '#4E8AC7',
  boxShadow: 'none',

  '&:hover': {
    bgcolor: '#447DB5',
    boxShadow: 'none'
  }
};